import React, { useState } from 'react';
import { Button, Modal, Table, Tooltip, Tabs, Typography } from 'antd';
import { currency } from '../../quotationProduct/formatNumber';
import { accAdd } from '../../../util/math';
import { QuestionCircleOutlined } from '@ant-design/icons';

const UnitPrice = (props) => {
  const { productInfo = [], status } = props;
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [tabsValue, setTabsValue] = useState('1');
  const showModal = () => {
    setIsModalOpen(true);
  };
  const handleOk = () => {
    setIsModalOpen(false);
  };
  const handleCancel = () => {
    setIsModalOpen(false);
  };

  // '订单状态：10-已创建；20-待发货；30-已发货|待收货；40-已完成；50-已取消'
  const statusNumberTitleConfig = {
    // 10: '已创建',
    //
    // 20: '待发货',
    20: {
      title: '数量',
      dataIndex: 'sale_number',
      key: 'sale_number',
    },
    // 30: '已发货',
    30: {
      title: `${tabsValue === '1' ? '' : '发货'}数量`,
      dataIndex: `${tabsValue === '1' ? 'sale_number' : 'deliver_number'}`,
      key: `${tabsValue === '1' ? 'sale_number' : 'deliver_number'}`,
    },
    // 40: '已完成',
    40: {
      title: `${tabsValue === '1' ? '' : '收货'}数量`,
      dataIndex: `${tabsValue === '1' ? 'sale_number' : 'receive_number'}`,
      key: `${tabsValue === '1' ? 'sale_number' : 'receive_number'}`,
    },
    // 50: '已取消',
    50: {
      title: '数量',
      dataIndex: 'sale_number',
      key: 'sale_number',
    },
  };

  const computedNumberTitleConfig = (status && statusNumberTitleConfig[status]) || {};

  const columns = [
    {
      title: '商品编码',
      dataIndex: 'sku_no',
      key: 'sku_no',
      render: (text) => <a>{text}</a>,
    },
    {
      title: '图片',
      dataIndex: 'product_img',
      key: 'product_img',
      render: (text) => <img src={text} alt='' style={{ width: 80 }} />,
    },
    {
      title: '商品名称',
      dataIndex: 'sku_name',
      key: 'sku_name',
      render: (text) => <a>{text}</a>,
    },
    // {
    //   title: '数量',
    //   dataIndex: 'sale_number',
    //   key: 'sale_number',
    //   render: (text) => <a>{text}</a>,
    // },
    {
      title: '规格',
      dataIndex: 'sale_norms',
      key: 'sale_norms',
      render: (text) => <a>{text}</a>,
    },
    computedNumberTitleConfig,
    {
      title: '单价',
      dataIndex: 'sale_price',
      key: 'sale_price',
      render: (text) => <a>¥{currency(text)}</a>,
    },
    {
      title: '进口关税费',
      dataIndex: 'tariff_cost',
      key: 'tariff_cost',
      render: (text) => <a>¥{currency(text)}</a>,
    },
    {
      title: '增值税费',
      dataIndex: 'tax_cost',
      key: 'tax_cost',
      render: (text) => <a>¥{currency(text)}</a>,
    },
  ];
  const columns1 = [{
    title: '平均费用',
    dataIndex: 'other_avg_cost',
    key: 'other_avg_cost',
    render: (text) => <a>¥{currency(text)}</a>,
  },
  {
    title: <>商品综合单价<Tooltip title='商品平均成本，由商品单价+增值税费+平均费用计算得出'><QuestionCircleOutlined style={{ cursor: 'pointer' }} /></Tooltip></>,
    dataIndex: 'complete_sale_price',
    key: 'complete_sale_price',
    render: (text, record) => <a>¥{currency(text)}</a>
  },
  {
    title: <>商品综合小计<Tooltip title='商品综合小计，由商品小计+进口关税税费+增值税费+商品产生费用计算得出'><QuestionCircleOutlined style={{ cursor: 'pointer' }} /></Tooltip></>,
    dataIndex: 'complete_total',
    key: 'complete_total',
    render: (text) => <a>¥{currency(text)}</a>
  },];
  const columns2 = [{
    title: '平均费用',
    dataIndex: 'deliver_other_avg_cost',
    key: 'deliver_other_avg_cost',
    render: (text) => <a>¥{currency(text)}</a>,
  },
  {
    title: <>商品综合单价<Tooltip title='商品平均成本，由商品综合小计费用/商品数量计算得出'><QuestionCircleOutlined style={{ cursor: 'pointer' }} /></Tooltip></>,
    dataIndex: 'deliver_complete_sale_price',
    key: 'deliver_complete_sale_price',
    render: (text) => <a>¥{currency(text)}</a>
  },
  {
    title: <>商品综合小计<Tooltip title='商品综合小计，由商品小计+进口关税税费+增值税费+商品产生费用计算得出'><QuestionCircleOutlined style={{ cursor: 'pointer' }} /></Tooltip></>,
    dataIndex: 'deliver_complete_total',
    key: 'deliver_complete_total',
    render: (text) => <a>¥{currency(text)}</a>
  },];
  const columns3 = [{
    title: '平均费用',
    dataIndex: 'receive_other_avg_cost',
    key: 'receive_other_avg_cost',
    render: (text) => <a>¥{currency(text)}</a>,
  },
  {
    title: <>商品综合单价<Tooltip title='商品平均成本，由商品综合小计费用/商品数量计算得出'><QuestionCircleOutlined style={{ cursor: 'pointer' }} /></Tooltip></>,
    dataIndex: 'receive_complete_sale_price',
    key: 'receive_complete_sale_price',
    render: (text) => <a>¥{currency(text)}</a>
  },
  {
    title: <>商品综合小计<Tooltip title='商品综合小计，由商品小计+进口关税税费+增值税费+商品产生费用计算得出'><QuestionCircleOutlined style={{ cursor: 'pointer' }} /></Tooltip></>,
    dataIndex: 'receive_complete_total',
    key: 'receive_complete_total',
    render: (text) => <a>¥{currency(text)}</a>
  },];

  const filterColumns = columns => columns.filter(item => item.title);
  const onTabsChange = value => setTabsValue(value);
  const items = [
    {
      label: '订单金额', key: '1', children: <Table columns={filterColumns([...columns, ...columns1])} dataSource={productInfo || []} rowKey='id' pagination={false}
        footer={() => <div style={{ textAlign: 'right', fontWeight: 600 }}>订单总金额：¥{currency(productInfo?.reduce((p, n) => accAdd(p, n.complete_total), 0))}</div>}
      />,
      isShow: true
    },
    {
      label: '预计应付金额', key: '2', children: <><div style={{ textAlign: 'right', marginBottom: 20 }}><Typography.Link>预计应付金额为按发货数量计算的金额，确认收货后将按实际收货数量计算最终的应付金额</Typography.Link></div>
        <Table columns={filterColumns([...columns, ...columns2])} dataSource={productInfo || []} rowKey='id' pagination={false}
          footer={() => <div style={{ textAlign: 'right', fontWeight: 600 }}>预计应付总金额：¥{currency(productInfo?.reduce((p, n) => accAdd(p, n.deliver_complete_total), 0))}</div>}
        /></>,
      isShow: +status === 30
    },
    {
      label: '应付金额', key: '3', children: <><div style={{ textAlign: 'right', marginBottom: 20 }}><Typography.Link>已按确认收货数量计算以下应付金额</Typography.Link></div>
        <Table columns={filterColumns([...columns, ...columns3])} dataSource={productInfo || []} rowKey='id' pagination={false}
          footer={() => <div style={{ textAlign: 'right', fontWeight: 600 }}>订单应付总金额：¥{currency(productInfo?.reduce((p, n) => accAdd(p, n.receive_complete_total), 0))}</div>}
        /></>,
      isShow: +status === 40
    },
  ];

  return (
    <>
      <div style={{ textAlign: 'right', margin: 20 }}>
        <Button type='primary' onClick={showModal}>商品综合单价</Button>
      </div>
      <Modal title="商品综合单价汇算" open={isModalOpen} onOk={handleOk} onCancel={handleCancel} footer={null} width={1200}>
        <Tabs defaultActiveKey="1" onChange={onTabsChange} items={items.filter(item => item.isShow)}>
          {/* <Tabs.TabPane tab="订单金额" key="1">
            <Table columns={filterColumns([...columns, ...columns1])} dataSource={productInfo || []} rowKey='id' pagination={false}
              footer={() => <div style={{ textAlign: 'right', fontWeight: 600 }}>订单总金额：¥{currency(productInfo?.reduce((p, n) => accAdd(p, n.complete_total), 0))}</div>}
            />
          </Tabs.TabPane>
          {+status === 30 ?
            <Tabs.TabPane tab="预计应付金额" key="2">
              <div style={{ textAlign: 'right', marginBottom: 20 }}><Typography.Link>预计应付金额为按发货数量计算的金额，确认收货后将按实际收货数量计算最终的应付金额</Typography.Link></div>
              <Table columns={filterColumns([...columns, ...columns2])} dataSource={productInfo || []} rowKey='id' pagination={false}
                footer={() => <div style={{ textAlign: 'right', fontWeight: 600 }}>预计应付总金额：¥{currency(productInfo?.reduce((p, n) => accAdd(p, n.deliver_complete_total), 0))}</div>}
              />
            </Tabs.TabPane> : null
          }
          {+status === 40 ?
            <Tabs.TabPane tab="应付金额" key="3">
              <div style={{ textAlign: 'right', marginBottom: 20 }}><Typography.Link>已按确认收货数量计算以下应付金额</Typography.Link></div>
              <Table columns={filterColumns([...columns, ...columns3])} dataSource={productInfo || []} rowKey='id' pagination={false}
                footer={() => <div style={{ textAlign: 'right', fontWeight: 600 }}>订单应付总金额：¥{currency(productInfo?.reduce((p, n) => accAdd(p, n.receive_complete_total), 0))}</div>}
              />
            </Tabs.TabPane> : null
          } */}
        </Tabs>
      </Modal>
    </>
  );
};
export default UnitPrice;